import React from 'react';
import { FilterMenu } from '@goodfynd/ui';
import { useMobileSize } from '@goodfynd/utils';
import NoSsr from '@mui/material/NoSsr';
import { useRouter } from 'next/router';

import {
  StyledDivider,
  StyledFiltersContainer,
  StyledForm,
  StyledInputsContainer,
} from './styles';
import type { ScheduleListEmbedSearchProps } from './types';

import classes from './ScheduleListEmbed.module.css';

export function ScheduleListEmbedSearch({
  css,
  dayOptions,
  forceMobile = false,
  geoSearch,
  selectedDate,
  setSelectedDate,
}: ScheduleListEmbedSearchProps) {
  const isMobile = useMobileSize();

  const {
    query: {
      day_picker_label = dayOptions[0]?.label || 'Next 5 days',
      hide_day_picker = 'false',
      hide_location_search = 'false',
    },
  } = useRouter();

  const showDayPicker = JSON.parse(hide_day_picker as string) !== true;
  const showLocationSearch =
    JSON.parse(hide_location_search as string) !== true;

  if (!(showDayPicker || showLocationSearch)) {
    return null;
  }

  return (
    <NoSsr>
      <StyledFiltersContainer
        css={{
          'form > div': {
            flexDirection: forceMobile ? 'column' : 'row',
          },
          ...css,
        }}
      >
        <StyledForm>
          <StyledInputsContainer>
            {showLocationSearch && geoSearch}

            {showDayPicker && (
              <>
                {showLocationSearch && (
                  <StyledDivider variant={isMobile ? 'fullWidth' : 'middle'} />
                )}

                <FilterMenu
                  className={classes['day-filter']}
                  labelEmpty={day_picker_label as string}
                  onChange={(option) => setSelectedDate(option)}
                  options={dayOptions}
                  selected={selectedDate}
                />
              </>
            )}
          </StyledInputsContainer>
        </StyledForm>
      </StyledFiltersContainer>
    </NoSsr>
  );
}
